module.exports = __webpack_public_path__ + "media/images/products/preview-633844207849d86a0a0f01dd1712449c.jpg";